<div class="row">
  <div class="col col-1 bold">
    Vaste activa
  </div>
  <div class="col-2 bold">
    Huidige periode
  </div>
  <div class="col-3 bold">
    Vorige periode
  </div>
</div>
<form [formGroup]="totalImvFg">
  <div class="row pt-3">
    <div class="col col-1">
      <p style="padding: 6px">Immateriële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalMvaFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Materiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalVastgoedFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Vastgoedbeleggingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalFvaFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Financiële vaste activa</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="somVastFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px"><b>Totaal van vaste activa</b></p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<div class="row">
  <div class="col col-1 bold">
    Vlottende activa
  </div>
  <div class="col-2 bold">
  </div>
  <div class="col-2 bold">
  </div>
</div>
<form [formGroup]="totalVoorrFg">
  <div class="row pt-3">
    <div class="col col-1">
      <p style="padding: 6px">Voorraden</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalOhwFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Onderhanden projecten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>

<form [formGroup]="totalVordFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Vorderingen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalEffFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Effecten</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="totalLmFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px">Liquide middelen</p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="somVlotFg">
  <div class="row">
    <div class="col col-1">
      <p style="padding: 6px"><b>Totaal van vlottende activa</b></p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
<form [formGroup]="somTotaalFg">
  <div class="row pt-3">
    <div class="col col-1 bold">
      Totaal van activa
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                        class="custom-input-150 custom-readonly"
                                        align="right"
                                        prefix="€"
                                        [showAllDecimals]="false"
                                        [disabledControl]="true"
      >
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
